@if (!contentLoaded) {
  <app-content-loader></app-content-loader>
}
@if (contentLoaded) {
  <div class="vollmacht-authorization columns is-desktop step-container">
    <!--aside-bar start-->
    <app-aside-bar [showEvenWithoutStatement]="true" [statement]="statement"></app-aside-bar>
    <!--aside-bar end-->
    <div class="vollmacht">
      <h1 class="title_42">
        {{ titleTranslationKey | translate }}
      </h1>
      <p class="subdesc">{{ descriptionTranslationKey | translate }}</p>
      <h2 class="vollmacht__iframe-label" [innerHTML]="'VOLLMACHTAUTHORIZATION.IFRAME_PROMPT_HTML' | translate"></h2>
      <div class="vollmacht__content">
        <app-yousign
          [statementId]="statementId"
          [(isVerified)]="canProceed"
          (signatureStepChange)="onSignatureStepChange($event)"
        ></app-yousign>
      </div>
    </div>
    <app-tools-bar [statement]="statement" [buttons]="buttons"></app-tools-bar>
  </div>
}
